<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newDeferredCashEntryBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Sospeso cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create px-3"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewDeferredCashEntry"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button>
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template
            v-slot:head(check)="data"
            v-if="hasChecks && !isCheckExclusive && items.length"
          >
            <base-checkbox
              v-model="checkAll"
              name="all"
              @change="
                onSelectAllRows();
                $emit('interaction', getSelectedRowsLength());
              "
              ><span v-if="data.label" v-html="data.label"></span>
            </base-checkbox>
          </template>
          <template #cell(check)="row" v-if="hasChecks">
            <base-checkbox
              name="check"
              v-model="row.item.check"
              @input="
                onSelectRow($event, row.index, row.item);
                $emit(
                  'interaction',
                  getSelectedRowsLength(),
                  row?.item?.data_registrazione,
                  row?.item?.check,
                );
              "
            />
          </template>
          <!-- <template #cell(remainder)="{ item }" v-if="items">
            {{ toLocaleCurrency(getRemainder(item)) }}
          </template> -->
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                :disabled="hasBeenDeferred(row.item)"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id, row.item)"
                :disabled="hasBeenDeferred(row.item)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(recovery_status)="{ item }">
            <status-badge kind="recovery" :status="recoveryStatus(item)" />
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <table-totals :items="totals" />
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import template from "./template";
import StatusBadge from "@/components/StatusBadge";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import General from "@/components/accounting/cash-entries/deferred/details/General";
import Deferred from "@/components/accounting/cash-entries/deferred/details/Deferred";
import BaseIcon from "@/components/BaseIcon";
import TableTotals from "@/components/TableTotals";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import moment from "moment";
import BaseInputPagination from "../form/BaseInputPagination.vue";
import EmptyTable from "@/components/EmptyTable.vue";

moment.locale("it");

export default {
  name: "DeferredCashEntriesTable",
  extends: template,
  data() {
    return {
      tabs: [
        { name: "General", text: "Generale" },
        { name: "Deferred", text: "Storico Recuperi" },
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
      dbRowData: null,
      args: { verb: { name: "sospesi", alias: "index" } },
    };
  },
  components: {
    StatusBadge,
    TableTotals,
    BaseInputPagination,
    General,
    BaseCheckbox,
    BaseIcon,
    Deferred,
    EmptyTable,
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    // Righe selezionate e totale da incassare nelle pillole dei totali,
    // accanto alla paginazione (components/TableTotals.vue).
    totals() {
      if (!(this.hasChecks && this.items.length)) return [];
      return [
        { label: "Righe selezionate", value: this.getSelectedRowsLength() },
        {
          label: "Totale da incassare",
          value: toLocaleCurrency(this.grandTotalDeferred),
        },
      ];
    },
    grandTotalDeferred() {
      if (!this.selectedRows.length) {
        return 0;
      }

      return this.items
        .filter((e) => this.selectedRows.includes(e.id))
        .reduce((valorePrecedente, sospeso) => {
          if (!sospeso.recupero) {
            return valorePrecedente + parseFloat(sospeso.importo);
          }

          if (parseFloat(sospeso.recupero) == parseFloat(sospeso.importo)) {
            return valorePrecedente;
          }

          return (
            valorePrecedente +
            (parseFloat(sospeso.importo) - parseFloat(sospeso.recupero))
          );
        }, 0);
    },
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newDeferredCashEntryBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toLocaleCurrency,
    toLocaleDate,
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewDeferredCashEntry() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    getSelectedRowsLength() {
      return this?.selectedRows?.[0] ? this.selectedRows.length : 0;
    },
    hasBeenDeferred(item) {
      if (item?.recupero) return true;
      return false;
    },
    totalDeferred(item) {
      if (!item?.reduced) {
        return false;
      }
      return this.getRemainder(item) === 0;
    },
    partialDeferred(item) {
      if (!item?.reduced) {
        return false;
      }
      return Math.abs(item?.reduced) < item?.gross;
    },
    getRemainder(item) {
      return item?.gross + item?.reduced;
    },
    // Stato di recupero: chiuso se il recupero copre l'importo, parziale se
    // c'è già un recupero, altrimenti aperto (toni in utils/statusBadge.js).
    recoveryStatus(item) {
      let value = 0;
      if (item?.recupero) value = item.importo === item.recupero ? 2 : 1;
      return {
        value,
        text: ["Aperto", "Parziale", "Chiuso"][value],
        title: value === 1 ? "Parzialmente recuperato" : null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/table-mixins";
@include table-check-column;
</style>
